import { SET_TOKEN } from "./types";

export default {
  // 格式: mutation: storeKey
  [SET_TOKEN]: "token",
};
